<template>
  <v-dialog v-model="toggle" max-width="500" persistent>
    <v-card
      class="pa-5"
    >
      <v-card-text class="mb-5">
        <h1 class="primary--text pb-5 pt-5">{{ title }}</h1>
        <h3>{{ message }}</h3>
      </v-card-text>

      <v-card-actions>
        <v-row class="mx-auto">
          <v-spacer></v-spacer>

          <base-button
            x-large
            name="Cancel"
            color="#ff605c"
            dark
            @click="toggle = false"
            min-width="30%"
          >
          </base-button>

          <v-spacer></v-spacer>

          <base-button
            x-large
            name="Yes"
            color="#258bf5"
            @click="doThis()"
            min-width="30%"
          >
          </base-button>

          <v-spacer></v-spacer>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "BaseConfirmDialog",

    props: {
      value: { type: Boolean, default: false },
      title: { type: String, default: '' },
      message: { type: String, default: '' },
    },

    data() {
      return {
        toggle: this.value
      }
    },

    methods: {
      doThis() {
        this.toggle = false;
        this.$emit('do');
      }
    },

    watch: {
      value(val) {
        this.toggle = val;
      },
      toggle(val) {
        this.$emit('input', val);
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>